/**
 * Returns a JS object representation of a Javascript Web Token from its common encoded
 * string form.
 *
 * @template T the expected shape of the parsed token
 * @param {string} token a Javascript Web Token in base64 encoded, `.` separated form
 * @returns {(object | undefined)} an object-representation of the token
 * or undefined if parsing failed
 */
function getParsedJwt(token: string): object | undefined {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch {
        return undefined;
    }
}

export function jwtDoesNotContainText(jwt: string, text: string): boolean {
    return !JSON.stringify(getParsedJwt(jwt)).includes(text);
}
